import { render, staticRenderFns } from "./StarterPage.vue?vue&type=template&id=63f4dcbb&scoped=true"
import script from "./StarterPage.vue?vue&type=script&lang=js"
export * from "./StarterPage.vue?vue&type=script&lang=js"
import style0 from "./StarterPage.vue?vue&type=style&index=0&id=63f4dcbb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f4dcbb",
  null
  
)

export default component.exports